<template lang="pug">

  section.timeline-header(:class="{sticky: sticky}")
    .bg-color
      .wrapper
        .col1
          a(href="https://laboratoriodecontenidos.cl/?ref=mtonline-peugeot", title="title", target="_blank").logo-lacomarca
            img(src="assets/images/logos-white/logo-laboratorio-de-contenidos-de-marca.svg", alt="Laboratorio de Contenidos de Marca")
          nav
            router-link(v-for="decade in getDecades" :key="decade.title" :to="`/play#decade-${decade.title}`", title="decade.title") {{decade.title}}'s
        .col2
          h3 Ritmo <br> Sobre Ruedas
          h4
            img(src="assets/images/logo-peugeot.png", alt="Peugeot")
    .videowrapper
      VideoPlayer

</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import VideoPlayer from '@/components/timeline/VideoPlayer'

  export default  {
    name: 'timeline-header',
    components: {
      VideoPlayer
    },
    props: {
      sticky: Boolean
    },
    data() {
      return {
      }
    },
    mounted() {
      const rect = this.$el.getBoundingClientRect()
      this.setTlHeight(rect.height)
    },
    methods: {
      ...mapActions([
        'setActiveDecade',
        'setTlHeight'
      ]),
      goToDecade(e){
        // console.log(e);
      }
    },
    watch: {
      getHeaderPosition(val){
        this.$el.style.setProperty('--headerposition', val)
      }
    },
    computed: {
      ...mapGetters([
        'getDecades',
        'getHeaderPosition'
      ]),
    }
}
</script>

<style scoped lang="scss">
  .bg-color{
    padding: 1rem 2rem;
    background-color: #1d1d1b;
    box-shadow: 0px 10px 20px rgba(0,0,0,0.4);
    position: relative;
    z-index: 5;
  }
  .timeline-header{
    position: relative;
    @media screen and (max-width: 900px){
      .bg-color{
        padding: 0.5rem;
      }
      .videowrapper{
        position: fixed;
        bottom: 100%;
        left: 0;
        right: 0;
        top: auto;
        transition: all .3s;
      }
    }

    &.sticky{
      position: fixed;
      left: 0;
      right: 0;
      top: 48px;
      z-index: 3;
      .videowrapper{
        @media screen and (max-width: 900px) {
          position: fixed;
          bottom: 0;
          left: 0;
          right: 0;
          top: auto;
        }
      }
    }
  }

  .col1{
    display: grid;
    align-items: center;
    grid-template-columns: 110px 1fr;
    grid-gap: 2rem;
    @media screen and (max-width: 900px){
      display: none;
    }
  }
  .wrapper {
    display: grid;
    grid-template-columns: 6fr 4fr;
    grid-gap: 3rem;
    align-items: center;
    // max-width: 1200px;
    margin-left: auto;
    margin-right: auto;
    @media screen and (max-width: 900px){
      grid-template-columns: 1fr;
    }
    .col2{
      display: grid;
      align-items: center;
      grid-template-columns: 1fr 1fr;
    }
  }
  h3{
    color: white;
    text-transform: uppercase;
    position: relative;
    font-size: 1.1em;
    padding-left: 12px;
    line-height: 1.1rem;
    margin: 0;
    @media screen and (max-width: 900px){
      font-size: 1rem;
      line-height: 0.8rem;
    }
    &:before{
      position: absolute;
      content: '';
      left: 0;
      top: 4px;
      bottom: 4px;
      border-left: 7px solid white;
      @media screen and (max-width: 900px){
        top: 0;
        bottom: 0;
        border-left: 4px solid white;
      }
    }
  }
  h4{
    padding: 0;
    margin: 0;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    img{
      max-height: 40px;
    }
  }
  nav{
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  a{
    color: white;
  }
  .videowrapper{
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
  }
</style>
